<h1 mat-dialog-title class="dialog-title-container">Page Activity - {{ data?.username }}</h1>
<div mat-dialog-content>
  <div class="table-container um-table-wrap">
    <table mat-table [dataSource]="dataSource" class="mat-table um-table um-table-dialog">
      <ng-container matColumnDef="timeStamp">
        <th class="col-time centered-sorted-header" mat-header-cell *matHeaderCellDef>TimeStamp</th>
        <td class="col-time centered-sorted-header" mat-cell *matCellDef="let element">{{ element?.timeStamp }}</td>
      </ng-container>

      <ng-container matColumnDef="pageType">
        <th class="col-page centered-sorted-header" mat-header-cell *matHeaderCellDef>Page Type</th>
        <td class="col-page centered-sorted-header" mat-cell *matCellDef="let element">{{ element?.pageType }}</td>
      </ng-container>

      <ng-container matColumnDef="subType">
        <th class="col-subtype centered-sorted-header" mat-header-cell *matHeaderCellDef>Sub Type</th>
        <td class="col-subtype centered-sorted-header" mat-cell *matCellDef="let element">{{ element?.subType }}</td>
      </ng-container>

      <ng-container matColumnDef="siteName">
        <th class="col-site left-sorted-header" mat-header-cell *matHeaderCellDef>Site Name</th>
        <td class="col-site left-sorted-header" mat-cell *matCellDef="let element">{{ element?.siteName }}</td>
      </ng-container>

      <ng-container matColumnDef="eventLink">
        <th class="col-link centered-sorted-header" mat-header-cell *matHeaderCellDef>Event Link</th>
        <td class="col-link centered-sorted-header" mat-cell *matCellDef="let element">
          <a *ngIf="element?.additionalInfo?.hdUrl" [href]="element?.additionalInfo?.hdUrl" target="_blank">View</a>
          <a *ngIf="element?.additionalInfo?.sdUrl" [href]="element?.additionalInfo?.hdUrl" target="_blank">View</a>
          <a *ngIf="element?.additionalInfo?.url" [href]="element?.additionalInfo?.url" target="_blank">NAS</a>
          <a *ngIf="element?.additionalInfo?.eventLink" [href]="element?.additionalInfo?.eventLink" target="_blank">View</a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="fetchData($event)"></mat-paginator>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()">Close</button>
</div>
